// Detección de nueva versión desplegada → recarga automática.
//
// Por qué: aunque nginx sirve index.html con `no-cache` (cada CARGA coge la
// última versión), una pestaña ya abierta seguiría ejecutando el JS viejo hasta
// que el usuario recargue. Esto lo cierra: comparamos el `asset-manifest.json`
// (su hash cambia en cada deploy) y, si hay versión nueva, recargamos solos.
//
// Cuándo comprueba:
//   1) al VOLVER a la pestaña (visibilitychange → visible), y
//   2) PERIÓDICAMENTE mientras la pestaña está visible (cada 60 s),
// para que un tab abierto se actualice solo en ~1 min tras un deploy, sin que
// el usuario tenga que recargar a mano.
//
// Resultado: cualquier navegador, en cualquier pestaña, acaba ejecutando
// siempre la última versión sin borrar caché ni recargar manualmente.

const INTERVALO_MS = 60000; // 60 s
let versionInicial = null;

async function leerVersion() {
  try {
    // no-store: nunca desde caché; siempre preguntamos al servidor.
    const res = await fetch("/asset-manifest.json", { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    // El path con hash del bundle principal es la huella de la versión.
    return (data && data.files && (data.files["main.js"] || JSON.stringify(data.files))) || null;
  } catch {
    return null;
  }
}

async function comprobarYRecargar() {
  if (document.visibilityState !== "visible" || !versionInicial) return;
  const actual = await leerVersion();
  if (actual && actual !== versionInicial) {
    // Hay un deploy nuevo: recargamos para ejecutar el último código.
    window.location.reload();
  }
}

export async function initVersionCheck() {
  versionInicial = await leerVersion();
  if (!versionInicial) return; // sin manifest (p. ej. en dev): no hacemos nada.

  document.addEventListener("visibilitychange", comprobarYRecargar);
  setInterval(comprobarYRecargar, INTERVALO_MS);
}
